export const CREATE_IDEA_SUCCESS = 'CREATE_IDEA_SUCCESS';
export const EDIT_IDEA_SUCCESS = 'EDIT_IDEA_SUCCESS';
export const ARCHIVE_IDEA_SUCCESS = 'ARCHIVE_IDEA_SUCCESS';
export const GET_IDEA_SUCCESS = 'GET_IDEA_SUCCESS';
export const GET_IDEAS_SUCCESS = 'GET_IDEAS_SUCCESS';
export const MOVE_CARD = 'MOVE_CARD';
export const MOVE_CARD_SUCCESS  = 'MOVE_CARD_SUCCESS';
export const GET_IDEAS_CONSTANTS_SUCCESS = 'GET_IDEAS_CONSTANTS_SUCCESS';
export const SEARCH_IDEAS = 'SEARCH_IDEAS';